import { render, staticRenderFns } from "./PaginationColumn.vue?vue&type=template&id=eb44e754&scoped=true&lang=pug&"
import script from "./PaginationColumn.vue?vue&type=script&lang=js&"
export * from "./PaginationColumn.vue?vue&type=script&lang=js&"
import style0 from "./PaginationColumn.vue?vue&type=style&index=0&id=eb44e754&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb44e754",
  null
  
)

export default component.exports